const environment = process.env;
export const APP_NAME = environment.VUE_APP_APP_NAME;
export const API_HOST = environment.VUE_APP_API_HOST;
export const CLIENT_SECRET = environment.VUE_APP_CLIENT_SECRET;
export const CLIENT_ID = environment.VUE_APP_CLIENT_ID;
export const GOOGLE_API_KEY = environment.VUE_APP_GOOGLE_API_KEY;
export const DOMAIN_LOCK = environment.VUE_APP_DOMAIN_LOCK;
